import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';
import { IControlViewModelConstructorParameter } from "#/CoreFrameInterfaces";
import DetailViewContext from "@/ViewModels/Contexts/DetailViewContext";
import { IDetailViewGroupDTO, IDVGItemDTO } from "coreframetypings/dto";
import ControlFactory from "@/Factories/ControlFactory";

interface IPropertyGroupBoxViewModelConstructorParameters extends IControlViewModelConstructorParameter {
    context?: DetailViewContext;
    layout?: string;
    detailViewGroups?: IDetailViewGroupDTO[];
    detailViewItems?: IDVGItemDTO[];
}

export default class PropertyGroupBoxViewModel extends ControlViewModel {

    /**
     * Der Kontext des ViewModels
     */
    public context: DetailViewContext;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout: string;

    /**
     * Enthält die inneren DetailViewGroups
     */
    public detailViewGroups: IDetailViewGroupDTO[];

    /**
     * Enthält die inneren DetailViewItems
     */
    public detailViewItems: IDVGItemDTO[];

    /**
     * Enthält die inneren Factories
     */
    public createdFactories: KnockoutObservable<ControlFactory[]>;

    /**
     * Das ViewModel für die PropertyGroupBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: IPropertyGroupBoxViewModelConstructorParameters) {
        super(params);

        this.context = this.paramOrDefault(params.context, null);
        this.layout = this.paramOrDefault(params.layout, 'NoneLayout');
        this.detailViewGroups = this.paramOrDefault(params.detailViewGroups, []);
        this.detailViewItems = this.paramOrDefault(params.detailViewItems, []);
        this.createdFactories = this.observableOrDefault([]);

        this.defineSubscription(this.isEnabled, (newValue: boolean) => {
            this.createdFactories().forEach((factory) => {
                if (!factory || factory.isDisposed)
                    return;

                factory.isEnabled(newValue);
            })
        });

        this.defineComputed(() => {
            if (this.isDisposed)
                return;

            for (let i = 0; i < this.createdFactories().length; i++) {
                let factory = this.createdFactories()[i];
                if (factory && !factory.isDisposed && typeof (factory.isValid) === "function" && factory.isValid() === false) {
                    this.isValid(false);
                    return;
                }
            }

            this.isValid(true);
        });
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }

}

ComponentManager.setViewModel('PropertyGroupBoxViewModel', PropertyGroupBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');